import React from "react";
import cn from "classnames";
import styles from "./navigation-text-with-icon.module.scss";

// Props for the NavigationTextWithIcon component
interface NavigationTextWithIconProps {
  label: string; // Text label for the button
  inActiveIcon?: string; // Icon to show when inactive
  activeIcon?: string; // Icon to show when active
  isActive?: boolean; // Determines if button is active
  onClick?: () => void; // Click handler
}

const cssClassName = "navigation-text-with-icon";

// Navigation button with optional active/inactive icon and label
const NavigationTextWithIcon = ({
  label,
  inActiveIcon,
  activeIcon,
  isActive,
  onClick,
}: NavigationTextWithIconProps) => {
  const icon = isActive ? activeIcon : inActiveIcon; // Choose icon based on active state
  return (
    <button
      className={styles[cssClassName]}
      onClick={() => onClick?.()} // Safely call onClick if defined
    >
      {icon && <img src={icon} alt={label} width="24" height="24" />}
      <p
        className={cn(styles[`${cssClassName}_label`], {
          [styles[`${cssClassName}__label--active`]]: isActive,
        })}
      >
        {label}
      </p>
    </button>
  );
};

export default NavigationTextWithIcon;
